import { ThemeOptions } from '@mui/material'

// NTNU style guide: https://i.ntnu.no/logo-og-maler

const ntnuTheme: ThemeOptions = {
  greg: {
    footerBgColor: '#272834',
    headerBgColor: 'white',
    headerTextColor: 'black',
    wizardButtonColor: 'black',
  },
  typography: {
    fontFamily: 'Open Sans',
  },
  palette: {
    primary: {
      main: '#00509e',
      light: '#ffffff',
    },
    secondary: {
      main: '#00509e',
      dark: '#6096d0',
      light: '#9db7e1',
    },
  },
}

export default ntnuTheme
